import {BoardContainer, TitleContainer} from "../../assets/GlobalStyles";
import React from "react";
import {useParams} from "react-router-dom";
import PlatformHistory from "./History";
import PlatformAdExchangeDetail from "./AdExchagneDetail";
import PlatformHistoryDetail from "./HistoryDetail";
import PlatformAdExchange from "./AdExchange";
import PlatformUserDetail from "./UserDetail";
import PlatformUser from "./User";
import PlatformAdminDetail from "./AdminDetail";
import PlatformTerm from "./Term";
import PlatformTermDetail from "./TermDetail";
import PlatformAdmin from "./Admin";
import PlatformCategoryManage from "./CategoryManage";

function Platform(){
  const params = useParams()
  const isMyPage = ['myPageUser', 'myPageAdmin'].includes(params.id);

  return(
    <main>
      <BoardContainer>
        <TitleContainer>
          <div>
            <h1>{isMyPage ? '마이페이지' : '플랫폼 관리'}</h1>
          </div>
        </TitleContainer>
        {params.id === 'platform' &&
          <PlatformUser/>
        }
        {params.id === 'platformUserDetail' &&
          <PlatformUserDetail/>
        }
        {params.id === 'platformAdmin' &&
            <PlatformAdmin/>
        }
        {params.id === 'platformAdminDetail' &&
            <PlatformAdminDetail/>
        }
        {params.id === 'platformTerm' &&
            <PlatformTerm/>
        }
        {params.id === 'platformTermDetail' &&
            <PlatformTermDetail/>
        }
        {params.id === 'platformCategory' &&
            <PlatformCategoryManage/>
        }
        {params.id === 'platformHistory' &&
          <PlatformHistory/>
        }
        {params.id === 'platformHistoryDetail' &&
          <PlatformHistoryDetail/>
        }
        {params.id === 'platformAdExchange' &&
          <PlatformAdExchange/>
        }
        {params.id === 'platformAdExchangeDetail' &&
          <PlatformAdExchangeDetail/>
        }
        {params.id === 'myPageUser' && <PlatformUserDetail/>}
        {params.id === 'myPageAdmin'&& <PlatformAdminDetail/>}
      </BoardContainer>
    </main>
  )
}

export default Platform
